import React, { useState, useEffect } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import CommonCard from '../../../Components/General/CommonCard';
import LabeledText from '../../../Components/General/LabeledText';
import PackageCard from '../../../Components/General/PackageCard';
import RadioButton from '../../../Components/UI/RadioButton';
import ToggleButton from '../../../Components/UI/ToggleButton';
import { packageList } from '../../../data/DummyData';

import PaymentMethodDrawer from '../../../Drawer/PaymentMethodDrawer';
import SMSPackageDetailCard from '../../../Components/General/SMSPackageDetailCard';
import PackagePendingCard from '../../../Components/General/PackagePendingCard';
import useSMSPackage from '../../../Features/useSMSPackage';
import SelectedPackageCard from '../../../Components/General/SelectedPackageCard';
import clsx from 'clsx';
import AlertModal from '../../../Modals/AlertModal';
import moment from 'moment-timezone';
import PaginationWrapper from '../../../Components/General/PaginationWrapper';
import Pagination from '../../../Components/General/Pagination';
import { checkDatePassed } from '../../../Helpers';
import NoDataFound from '../../../Components/General/NoDataFound';
import classes from './Subscription.module.css';
import ShortSMSPackageCard from '../../../Components/General/ShortSMSPackageCard';
import Button from '../../../Components/UI/Button';
import { toast } from 'react-toastify';
const SubscriptionPage = ({
  smsPackagesList,
  subscriptionList,
  onCancelRequest,
  loading,
  getSmsSubscription,
  onAddSubscription,
  onAddMergeSubscription,
  onAddSmsSubscription,
  packages
}) => {
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [showAreYouCancelSubscriptionRequest, setShowAreYouCancelSubscriptionRequest] =
    useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [showPaymentMethodDrawer, setShowPaymentMethodDrawer] = useState(false);
  const togglePaymentMethodDrawer = () => {
    setShowPaymentMethodDrawer((current) => !current);
  };
  const [selectedSmsPackage, setSelectedSmsPackage] = useState(null);
  const [selectedPendingSubscription, setSelectedPendingSubscription] = useState(null);

  const pendingSubscriptionList = subscriptionList?.data?.filter(
    (data) => data?.isPaid === false && data?.isCancelled === false
  );

  // Define the time zone (e.g., 'America/New_York')

  const selectedPackageList = subscriptionList?.data?.filter(
    (data) =>
      data?.isPaid && checkDatePassed(data?.subscriptionStartDate, data?.subscriptionEndDate)
  );

  const drawSubscriptionHistory = subscriptionList?.data?.filter(
    (data) =>
      !checkDatePassed(data?.subscriptionStartDate, data?.subscriptionEndDate) && data?.isPaid
  );

  const onSuccess = () => {
    setSelectedPackage(null);
    setSelectedPackage(null);
    togglePaymentMethodDrawer();
  };
  return (
    <>
      <section className={classes.pageWrapper}>
        <Row>
          {packages?.map((data, index) => (
            <PackageCard
              viewDetails={true}
              setter={() => {
                setSelectedPackage(data?.packageID);
              }}
              markSelected={selectedPackage === data?.packageID}
              data={data}
              headerCard={data?.packageName?.startsWith('3 Month')}
            />
          ))}
        </Row>
      </section>
      <section>
        <Row>
          <Col lg={5}>
            <CommonCard className={classes.bgWhite}>
              <ul className={clsx(classes.packagePendingWrapper, 'scrollbar1')}>
                {pendingSubscriptionList?.map((data) => (
                  <li key={data?.rowNum}>
                    <PackagePendingCard
                      data={data}
                      onCancelRequest={() => {
                        setSelectedPendingSubscription(data);
                        setShowAreYouCancelSubscriptionRequest(true);
                      }}
                    />
                  </li>
                ))}
              </ul>
              <ul className={classes.selectedPackageWrapper}>
                <li>
                  <SelectedPackageCard />
                </li>
              </ul>
              <h3 className={classes.smsBundleHeading}>SMS Bundles</h3>
              <ul>
                {smsPackagesList?.map((data) => (
                  <li
                    key={data?.packageID}
                    className={clsx({
                      [classes.headerCardMarginTop]: data?.packageName?.startsWith('Standard')
                    })}>
                    <ShortSMSPackageCard
                      setter={() => {
                        setSelectedSmsPackage(data?.packageID);

                        // togglePaymentMethodDrawer();
                      }}
                      markSelected={selectedSmsPackage === data?.packageID}
                      data={data}
                      headerCard={data?.packageName?.startsWith('Standard')}
                    />
                  </li>
                ))}
              </ul>

              <ul className={classes.wrapperOfAllGeneralInfo}>
                <LabeledText
                  className={classes.generalInfo}
                  Tag="li"
                  label={'Subscription Amount'}
                  value={`Rs. 5,000`}
                />

                <LabeledText
                  className={classes.generalInfo}
                  Tag="li"
                  label={'Subscription Amount'}
                  value={`Rs. 5,000`}
                />

                <LabeledText
                  className={classes.totalWrapper}
                  Tag="li"
                  label={'Total'}
                  value={`Rs. 5,000`}
                />
              </ul>

              <div className={classes.bottomAction}>
                <Button
                  label={'Choose This Plan'}
                  disabled={!(selectedPackage || selectedSmsPackage)}
                  onClick={() => {
                    if (selectedPackage || selectedSmsPackage) {
                      togglePaymentMethodDrawer();
                    } else {
                      toast.error('Please Select the package');
                    }
                  }}
                />
              </div>
            </CommonCard>
          </Col>
          <Col lg={7}>
            <CommonCard className={classes.bgWhite}>
              <h2 className={classes.historyTitle}>Subscription History</h2>
              <Row>
                {drawSubscriptionHistory?.length > 0 ? (
                  drawSubscriptionHistory?.map((data) => (
                    <Col md={6} className={classes.smsPackageCardWrapper}>
                      <SMSPackageDetailCard data={data} />
                    </Col>
                  ))
                ) : (
                  <NoDataFound label="No Subscription History Found" />
                )}
              </Row>
              <footer>
                <PaginationWrapper>
                  <Pagination
                    limit={10}
                    totalCount={totalCount}
                    page={page}
                    setPage={(e) => {
                      setPage(e);
                      getSmsSubscription(e);
                    }}
                  />
                </PaginationWrapper>
              </footer>
            </CommonCard>
          </Col>
        </Row>
      </section>
      <PaymentMethodDrawer
        setSelectedPackage={setSelectedPackage}
        data={selectedSmsPackage}
        show={showPaymentMethodDrawer}
        setShow={() => {
          togglePaymentMethodDrawer();
        }}
        onSubmit={() => {
          if (selectedPackage && selectedSmsPackage) {
            onAddMergeSubscription(
              {
                packageId: selectedPackage,
                smsPackageId: selectedSmsPackage,
                paymentMode: 'Cash'
              },
              onSuccess
            );
          } else if (selectedPackage) {
            onAddSubscription({ packageId: selectedPackage, paymentMode: 'Cash' }, onSuccess);
          } else if (selectedSmsPackage) {
            onAddSmsSubscription({ packageId: selectedSmsPackage, paymentMode: 'Cash' }, onSuccess);
          }
        }}
      />
      {showAreYouCancelSubscriptionRequest && (
        <AlertModal
          loading={loading}
          title={'Delete Service'}
          content={
            <span>
              Are you sure you want to cancel subscription request{' '}
              <span className={classes.contentName}>
                {selectedPendingSubscription?.serviceName}{' '}
              </span>
            </span>
          }
          onConfirm={() =>
            onCancelRequest({ subscriptionId: selectedPendingSubscription?.subscriptionID }, () => {
              setSelectedPendingSubscription(null);
              setShowAreYouCancelSubscriptionRequest();
            })
          }
          show={showAreYouCancelSubscriptionRequest}
          setShow={setShowAreYouCancelSubscriptionRequest}
        />
      )}
    </>
  );
};

export default SubscriptionPage;
